import React, { Component, Fragment } from "react";
import { Image } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router-dom";
import * as actions from "../../store/actions/index.js";
import logo from "../../assets/images/amps-logo.png";
import Input from "../../components/UI/Input/Input";
import Button from "../../components/UI/Button/Button";
import RoutePath from "../RoutePath/RoutePath";
import Spinner from "../../components/UI/Spinner/Spinner";
import InfoWindow from "../../components/UI/Alerts/InfoWindow/InfoWindow";
import Modal from "../../components/UI/Modal/Modal";
import LoginAlert from "../../components/UI/Alerts/LoginAlert/LoginAlert";

interface IStatefromProps {
  token: string;
  loading: boolean;
  impersonate:boolean,
  impersonateErrorMessage:string,
  error:boolean
}
interface IDispatchFromProps {
    onFetchImpersonatedAccessToken: (email: string) => void;
}

type Props = IStatefromProps & IDispatchFromProps & RouteComponentProps;
class Impersonation extends Component<Props> {
  state = {
    email: "",
    error:false,
    errorMessage:""
  };
  componentDidMount(){
      if(!this.props.impersonate){
        this.props.history.push('/home')
      }
  }
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onChangeShowPassword = (event) => {
    console.log(event.target.checked, event.target.name);
    if (event.target.checked) {
      this.setState({ showPassword: true });
    } else if (!event.target.checked) {
      this.setState({ showPassword: false });
    }
  };
  openLinkClicked = (e) => {
    console.log("link clicked", e.target.innerText);
    localStorage.setItem("linkClicked", e.target.innerText);
  };

  closeLinkClicked = () => {
    this.setState({ linkClicked: false });
    localStorage.removeItem("linkClicked");
  };
   validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };
  render() {
    const clickHandler = async () => {
      if(!this.validateEmail(this.state.email)){
        this.setState({error:true,errorMessage:"please enter valid email address"})
      }else{
        this.setState({error:false,errorMessage:""})
         this.props.onFetchImpersonatedAccessToken(this.state.email)
      }
    };

    const elementLabelStyle = {
      display: "none",
    };
    const elementInputStyle = {
      fontSize: "1em",
      border: "0",
    };
    const alertModal = {
      width: "360px",
      left: "calc(50% - 180px)",
      top: "33%",
    };
    const btnStyle = {
      borderRadius: "5px",
      width: "100%",
      marginTop: "20px",
    };

    let spinner: any;
    if (this.props.loading) {
      spinner = <Spinner />;
    }

    let linkClicked: any;

  
      let loggedIn = (
        <div className="custom-wrapper">
          <div className="custom-box">
            <div className="c-logo">
              <Image src={logo} alt="logo" />
            </div>
            <h2>Sign-in on behalf of</h2>
            {this.props.error && (
              <div className="login-error login-error-alert">
                {this.props.impersonateErrorMessage}
              </div>
            )}
            <div className="custom-form">
              <Input
                label=""
                supportLabel=""
                type="email"
                placeholder="Email Address"
                elementLabelStyle={elementLabelStyle}
                elementInputStyle={elementInputStyle}
                name="email"
                errorText=""
                value={this.state.email}
                onChange={(e) => this.handleChange(e)}
              />
              {/* {this.state.loginClicked && this.state.password === "" && (
                <div className="login-error">Please enter your password</div>
              )} */}
              {/* <Input
                label=""
                type={this.state.showPassword ? "text" : "password"}
                supportLabel=""
                placeholder="Password"
                elementLabelStyle={elementLabelStyle}
                elementInputStyle={elementInputStyle}
                name="password"
                errorText=""
                value={this.state.password}
                onChange={(e) => this.handleChange(e)}
              />
              <div className="show-pwd">
                <label>
                  <input
                    type="checkbox"
                    id="customSwitches"
                    onChange={this.onChangeShowPassword}
                  />{" "}
                  Show password
                </label>
              </div> */}
              <Button
                label="Login"
                clicked={clickHandler}
                style={btnStyle}
                displayImg={false}
                image=""
                disabled={false}
              />
              <div
                className="row mt-3"
                onClick={(e) => this.openLinkClicked(e)}
              >
                <div className="col-6">
                  {/* <a className="c-link" onClick={this.onForgotPassword}> */}
                  <a
                    className="c-link"
                    onClick={()=>{
                        sessionStorage.removeItem("impersonate")
                        this.props.history.push("/")   
                        this.forceUpdate() 
                        window.location.reload()
                    }}
                  >
                    Back
                  </a>
                </div>
               
              </div>
              <div className="c-terms">
                <a
                  className="t-link"
                  href="https://ampsqa.blob.core.windows.net/ampsqa/terms-web.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms of use
                </a>
              </div>
            </div>
          </div>
        </div>
      )
        return (
            <Fragment>
              {spinner}
              {loggedIn}
              {linkClicked}
            </Fragment>
          );
    
  }
}
const mapStateToProps = (state: any) => {
    console.log("redux state",state)
    return({

  token: state.fetchAccessToken.token,
  loading: state.fetchAccessToken.loading,
  error: state.appConfig.error,
  errorMessage: state.fetchAccessToken.errorMessage,
  impersonate:state.appConfig.impersonate,
  impersonateErrorMessage:state.appConfig.impersonateErrorMessage
})};
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onFetchImpersonatedAccessToken: (email) =>
    dispatch(actions.fetchImpersonatedUserToken(localStorage.getItem('userId'),email)),
    
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Impersonation));
